export default __webpack_public_path__ + "static/media/Gitkraken.15c9b132.png";